import React, { ComponentProps } from 'react'

export const ExportIcon = (props: ComponentProps<'svg'>) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            color="#333333"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                id="Path 838"
                d="M1.29102 11.182V12.807C1.29102 13.238 1.46222 13.6513 1.76697 13.9561C2.07171 14.2608 2.48504 14.432 2.91602 14.432H12.666C13.097 14.432 13.5103 14.2608 13.8151 13.9561C14.1198 13.6513 14.291 13.238 14.291 12.807V11.182M11.041 7.93201L7.79102 11.182M7.79102 11.182L4.54102 7.93201M7.79102 11.182V1.43201"
                stroke="currentcolor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    )
}
